import { motion } from "framer-motion";
import { Check } from "lucide-react";

const POINTS = [
    "Transparent itemized pricing",
    "Daily auto site report on WhatsApp",
    "Full construction video journey",
    "Modern + Vastu-aligned designs",
    "Experienced in-house team",
    "Premium quality branded materials",
    "End-to-end turnkey solutions",
    "Timely milestone delivery",
];

const IMG = "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1400&q=80";

export default function WhyChooseUs() {
    return (
        <section className="relative bg-white py-20 md:py-32" data-testid="why-choose-us-section">
            <div className="max-w-7xl mx-auto px-5 md:px-10 grid lg:grid-cols-12 gap-12 items-center">
                <div className="lg:col-span-5 order-2 lg:order-1">
                    <motion.div
                        initial={{ opacity: 0, y: 16 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6 }}
                        className="flex items-center gap-3 mb-6"
                    >
                        <span className="w-8 h-px bg-brand-orange" />
                        <span className="text-[11px] uppercase tracking-[0.25em] text-brand-orange font-medium">Why choose us</span>
                    </motion.div>

                    <motion.h2
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.7 }}
                        className="font-display font-semibold text-brand-ink text-3xl md:text-4xl lg:text-[44px] leading-[1.05] tracking-tight"
                        data-testid="why-choose-us-heading"
                    >
                        Built different. <span className="font-serif-italic font-normal brand-gradient-text">Built right.</span>
                    </motion.h2>

                    <ul className="mt-10 space-y-4">
                        {POINTS.map((pt, i) => (
                            <motion.li
                                key={pt}
                                initial={{ opacity: 0, x: -20 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                viewport={{ once: true, margin: "-30px" }}
                                transition={{ duration: 0.5, delay: i * 0.06 }}
                                className="flex items-center gap-4"
                                data-testid={`why-point-${i}`}
                            >
                                <span className="w-7 h-7 rounded-full brand-gradient flex items-center justify-center shrink-0">
                                    <Check size={13} className="text-white" strokeWidth={3} />
                                </span>
                                <span className="text-[15px] md:text-base text-brand-ink">
                                    {pt}
                                </span>
                            </motion.li>
                        ))}
                    </ul>
                </div>

                <motion.div
                    initial={{ opacity: 0, scale: 0.95 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
                    className="lg:col-span-7 order-1 lg:order-2 relative"
                >
                    <div className="aspect-[4/3] rounded-[28px] overflow-hidden">
                        <img src={IMG} alt="Premium construction quality" className="w-full h-full object-cover" loading="lazy" />
                    </div>
                    <div className="absolute bottom-5 right-5 glass rounded-2xl p-4 max-w-[240px] ring-1 ring-black/5">
                        <div className="flex items-center gap-1 text-[#FF8800] mb-1.5">
                            {[...Array(5)].map((_, i) => (
                                <span key={i} className="text-sm">★</span>
                            ))}
                        </div>
                        <div className="font-display font-semibold text-brand-ink text-[15px]">Trusted by 100+ Udaipur families</div>
                        <div className="text-[11px] text-brand-muted mt-1">Average 4.9 / 5 across reviews.</div>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
